import {
  formatIssues,
  isValidationErrorMessage,
} from '@festina-life/components'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import { useOperationsContext } from '../../workspace/operationsContext'
import { CriticalError } from './CriticalError'
import { ErrorsDisclosure } from './ErrorsDisclosure'
import { pickNonOperationSpecificErrors } from './helpers'

export const CriticalErrors = () => {
  const translate = useTranslate()
  const {
    workspaceKey,
    errors,
    workspaceValidationErrors,
    branchValidationErrors,
  } = useOperationsContext()
  const nonOperationApplicationErrors = useMemo(
    () => pickNonOperationSpecificErrors(errors),
    [errors],
  )

  const locationValidationErrors = workspaceKey
    ? workspaceValidationErrors
    : branchValidationErrors
  const totalErrorCount =
    nonOperationApplicationErrors.length + (locationValidationErrors.size ?? 0)

  return (
    <ErrorsDisclosure
      title={translate('errorPanel.criticalErrors.title')}
      count={totalErrorCount}
    >
      {!totalErrorCount && (
        <Alert severity="info" title={translate('errorPanel.empty')} />
      )}
      {Array.from(locationValidationErrors.entries()).map(
        ([block, layerErrors]) =>
          Array.from(layerErrors.entries()).map(([layer, validationError]) => (
            <Alert
              key={`${block}-${layer.toString()}`}
              severity="error"
              title={translate('locationValidationError.errorMessage', {
                message: isValidationErrorMessage(validationError)
                  ? formatIssues(validationError)
                  : (validationError.message ?? ''),
              })}
            />
          )),
      )}
      {nonOperationApplicationErrors?.map((validationError, index) => (
        <CriticalError
          // oxlint-disable-next-line react/no-array-index-key
          key={`${validationError.error.errorMessage}-${index}`}
          validationError={validationError}
        />
      ))}
    </ErrorsDisclosure>
  )
}
